export const mockServices = [
  {
    id: 1,
    icon: 'Laptop',
    title: 'Ремонт ноутбуків',
    description: 'Діагностика, ремонт материнських плат, заміна екранів, клавіатур, жорстких дисків',
    features: ['Безкоштовна діагностика', 'Гарантія на роботу', 'Ремонт від 1 години']
  },
  {
    id: 2,
    icon: 'WashingMachine',
    title: 'Чистка ноутбуків',
    description: 'Професійна чистка від пилу, заміна термопасти, профілактика системи охолодження',
    features: ['Зниження температури', 'Усунення шуму', 'Швидкість як нова']
  },
  {
    id: 3,
    icon: 'Smartphone',
    title: 'Ремонт телефонів',
    description: 'Заміна екранів, батарей, камер, ремонт плат, відновлення після води',
    features: ['Оригінальні деталі', 'Ремонт за 30-60 хв', 'Гарантія якості']
  },
  {
    id: 4,
    icon: 'Tablet',
    title: 'Ремонт планшетів',
    description: 'Заміна дисплеїв, акумуляторів, роз\'ємів, ремонт програмних проблем',
    features: ['Всі бренди', 'Якісні комплектуючі', 'Доступні ціни']
  },
  {
    id: 5,
    icon: 'Gamepad2',
    title: 'Обслуговування ігрових консолей',
    description: 'PlayStation, Xbox, Nintendo - чистка, ремонт, заміна термопасти, профілактика',
    features: ['Усунення перегріву', 'Тиха робота', 'Продовження терміну служби']
  },
  {
    id: 6,
    icon: 'HardDrive',
    title: 'Оновлення та модернізація',
    description: 'Збільшення оперативної пам\'яті, встановлення SSD, оновлення системи',
    features: ['Підвищення швидкості', 'Консультація експерта', 'Встановлення ПЗ']
  },
  {
    id: 7,
    icon: 'HardDrive',
    title: 'Збірка комп\'ютерів',
    description: 'Індивідуальна збірка ПК під ваші потреби: ігрові, робочі, мультимедійні',
    features: ['Підбір комплектуючих', 'Оптимальні ціни', 'Гарантія на збірку']
  },
  {
    id: 8,
    icon: 'HardDrive',
    title: 'Ремонт зарядних станцій',
    description: 'Діагностика та ремонт зарядних пристроїв для ноутбуків, телефонів, планшетів',
    features: ['Швидка діагностика', 'Якісний ремонт', 'Доступні ціни']
  }
];

export const mockPrices = [
  { id: 1, service: 'Діагностика (всі пристрої)', price: 'Безкоштовно' },
  { id: 2, service: 'Чистка ноутбука від пилу', price: 'від 700 грн' },
  { id: 3, service: 'Заміна термопасти', price: 'від 300 грн' },
  { id: 4, service: 'Заміна екрану ноутбука', price: 'від 1500 грн' },
  { id: 5, service: 'Ремонт материнської плати', price: 'від 800 грн' },
  { id: 6, service: 'Заміна клавіатури', price: 'від 1000 грн' },
  { id: 7, service: 'Заміна акумулятора ноутбука', price: 'від 1200 грн' },
  { id: 8, service: 'Встановлення SSD', price: 'від 700 грн' },
  { id: 9, service: 'Заміна екрану телефону', price: 'від 800 грн' },
  { id: 10, service: 'Заміна батареї телефону', price: 'від 400 грн' },
  { id: 11, service: 'Ремонт після попадання води', price: 'від 600 грн' },
  { id: 12, service: 'Чистка ігрової приставки', price: 'від 900 грн' },
  { id: 13, service: 'Збірка ігрового ПК', price: 'від 1500 грн' },
  { id: 14, service: 'Збірка офісного ПК', price: 'від 800 грн' },
  { id: 15, service: 'Ремонт зарядного пристрою', price: 'від 300 грн' },
  { id: 16, service: 'Прискорення ноутбука (SSD+RAM)', price: 'від 1000 грн' }
];

export const mockTestimonials = [
  {
    id: 1,
    name: 'Олександр М.',
    rating: 5,
    text: 'Відмінний сервіс! Відремонтували ноутбук за 2 години. Майстри професіонали своєї справи. Ціни адекватні, робота якісна.',
    service: 'Ремонт ноутбука'
  },
  {
    id: 2,
    name: 'Марина К.',
    rating: 5,
    text: 'Дуже задоволена! Замінили екран на iPhone швидко і якісно. Дали гарантію. Рекомендую!',
    service: 'Заміна екрану телефону'
  },
  {
    id: 3,
    name: 'Дмитро П.',
    rating: 5,
    text: 'Почистили PlayStation 5 - тепер працює тихо і не перегрівається. Майстри знають свою справу, все пояснили і показали.',
    service: 'Чистка PS5'
  },
  {
    id: 4,
    name: 'Анна В.',
    rating: 5,
    text: 'Звернулася з проблемою води в телефоні. Відновили за день! Дякую за професіоналізм!',
    service: 'Ремонт після води'
  },
  {
    id: 5,
    name: 'Сергій Л.',
    rating: 5,
    text: 'Встановили SSD замість HDD - ноутбук летає! Ціна відмінна, робота швидка. Рекомендую всім!',
    service: 'Встановлення SSD'
  },
  {
    id: 6,
    name: 'Ірина Т.',
    rating: 5,
    text: 'Чудовий сервіс! Почистили ноутбук, тепер не гріється і працює тихо. Дякую!',
    service: 'Чистка ноутбука'
  }
];

export const mockGallery = [
  {
    id: 1,
    url: 'https://images.unsplash.com/photo-1588872657578-7efd1f1555ed?w=800',
    alt: 'Ремонт ноутбука',
    category: 'laptop'
  },
  {
    id: 2,
    url: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800',
    alt: 'Майстерня',
    category: 'workshop'
  },
  {
    id: 3,
    url: 'https://images.unsplash.com/photo-1556656793-08538906a9f8?w=800',
    alt: 'Ремонт телефону',
    category: 'phone'
  },
  {
    id: 4,
    url: 'https://images.unsplash.com/photo-1530893609608-32a9af3aa95c?w=800',
    alt: 'Інструменти',
    category: 'tools'
  },
  {
    id: 5,
    url: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?w=800',
    alt: 'Робочий процес',
    category: 'work'
  },
  {
    id: 6,
    url: 'https://images.unsplash.com/photo-1593640408182-31c70c8268f5?w=800',
    alt: 'Чистка консолі',
    category: 'console'
  }
];

export const mockBookings = [];

export const laptopRepairData = {
  Apple: {
    models: ['MacBook Pro 16" M3', 'MacBook Pro 14" M3', 'MacBook Air M2', 'MacBook Air M1', 'MacBook Pro 16" Intel', 'MacBook Pro 13" Intel'],
    repairs: {
      'Заміна екрану': { 'MacBook Pro 16" M3': 15000, 'MacBook Pro 14" M3': 12000, 'MacBook Air M2': 8000, 'MacBook Air M1': 7000, 'MacBook Pro 16" Intel': 10000, 'MacBook Pro 13" Intel': 8000 },
      'Заміна батареї': { 'MacBook Pro 16" M3': 4500, 'MacBook Pro 14" M3': 4000, 'MacBook Air M2': 3000, 'MacBook Air M1': 2800, 'MacBook Pro 16" Intel': 3500, 'MacBook Pro 13" Intel': 3000 },
      'Заміна клавіатури': { 'MacBook Pro 16" M3': 5000, 'MacBook Pro 14" M3': 4500, 'MacBook Air M2': 3500, 'MacBook Air M1': 3200, 'MacBook Pro 16" Intel': 4000, 'MacBook Pro 13" Intel': 3500 },
      'Ремонт материнської плати': { 'MacBook Pro 16" M3': 8000, 'MacBook Pro 14" M3': 7000, 'MacBook Air M2': 5000, 'MacBook Air M1': 4500, 'MacBook Pro 16" Intel': 6000, 'MacBook Pro 13" Intel': 5000 },
      'Заміна SSD': { 'MacBook Pro 16" M3': 6000, 'MacBook Pro 14" M3': 5500, 'MacBook Air M2': 4000, 'MacBook Air M1': 3500, 'MacBook Pro 16" Intel': 4500, 'MacBook Pro 13" Intel': 4000 },
      'Ремонт після води': { 'MacBook Pro 16" M3': 5000, 'MacBook Pro 14" M3': 4500, 'MacBook Air M2': 3500, 'MacBook Air M1': 3000, 'MacBook Pro 16" Intel': 4000, 'MacBook Pro 13" Intel': 3500 }
    }
  },
  Dell: {
    models: ['XPS 15', 'XPS 13', 'Inspiron 15', 'Inspiron 14', 'Latitude 5540', 'Latitude 3520'],
    repairs: {
      'Заміна екрану': { 'XPS 15': 8000, 'XPS 13': 7000, 'Inspiron 15': 4000, 'Inspiron 14': 3500, 'Latitude 5540': 5000, 'Latitude 3520': 4000 },
      'Заміна батареї': { 'XPS 15': 2500, 'XPS 13': 2200, 'Inspiron 15': 1500, 'Inspiron 14': 1300, 'Latitude 5540': 1800, 'Latitude 3520': 1500 },
      'Заміна клавіатури': { 'XPS 15': 2000, 'XPS 13': 1800, 'Inspiron 15': 1200, 'Inspiron 14': 1000, 'Latitude 5540': 1400, 'Latitude 3520': 1200 },
      'Ремонт материнської плати': { 'XPS 15': 6000, 'XPS 13': 5500, 'Inspiron 15': 3500, 'Inspiron 14': 3000, 'Latitude 5540': 4000, 'Latitude 3520': 3500 },
      'Заміна SSD': { 'XPS 15': 3000, 'XPS 13': 2800, 'Inspiron 15': 2000, 'Inspiron 14': 1800, 'Latitude 5540': 2200, 'Latitude 3520': 2000 },
      'Ремонт після води': { 'XPS 15': 4000, 'XPS 13': 3500, 'Inspiron 15': 2500, 'Inspiron 14': 2200, 'Latitude 5540': 3000, 'Latitude 3520': 2500 }
    }
  },
  HP: {
    models: ['Pavilion 15', 'Pavilion 14', 'ProBook 450', 'EliteBook 840', 'Envy 13', 'Omen 16'],
    repairs: {
      'Заміна екрану': { 'Pavilion 15': 4000, 'Pavilion 14': 3500, 'ProBook 450': 4500, 'EliteBook 840': 6000, 'Envy 13': 5000, 'Omen 16': 7000 },
      'Заміна батареї': { 'Pavilion 15': 1500, 'Pavilion 14': 1300, 'ProBook 450': 1600, 'EliteBook 840': 2000, 'Envy 13': 1800, 'Omen 16': 2200 },
      'Заміна клавіатури': { 'Pavilion 15': 1200, 'Pavilion 14': 1000, 'ProBook 450': 1300, 'EliteBook 840': 1600, 'Envy 13': 1400, 'Omen 16': 1800 },
      'Ремонт материнської плати': { 'Pavilion 15': 3500, 'Pavilion 14': 3000, 'ProBook 450': 4000, 'EliteBook 840': 5000, 'Envy 13': 4500, 'Omen 16': 6000 },
      'Заміна SSD': { 'Pavilion 15': 2000, 'Pavilion 14': 1800, 'ProBook 450': 2200, 'EliteBook 840': 2800, 'Envy 13': 2500, 'Omen 16': 3000 },
      'Ремонт після води': { 'Pavilion 15': 2500, 'Pavilion 14': 2200, 'ProBook 450': 3000, 'EliteBook 840': 3500, 'Envy 13': 3200, 'Omen 16': 4000 }
    }
  },
  Lenovo: {
    models: ['ThinkPad X1 Carbon', 'ThinkPad T14', 'IdeaPad 3', 'IdeaPad 5', 'Legion 5', 'Legion 7'],
    repairs: {
      'Заміна екрану': { 'ThinkPad X1 Carbon': 7000, 'ThinkPad T14': 5000, 'IdeaPad 3': 3000, 'IdeaPad 5': 3500, 'Legion 5': 6000, 'Legion 7': 8000 },
      'Заміна батареї': { 'ThinkPad X1 Carbon': 2200, 'ThinkPad T14': 1800, 'IdeaPad 3': 1200, 'IdeaPad 5': 1400, 'Legion 5': 2000, 'Legion 7': 2500 },
      'Заміна клавіатури': { 'ThinkPad X1 Carbon': 1800, 'ThinkPad T14': 1500, 'IdeaPad 3': 1000, 'IdeaPad 5': 1200, 'Legion 5': 1600, 'Legion 7': 2000 },
      'Ремонт материнської плати': { 'ThinkPad X1 Carbon': 5500, 'ThinkPad T14': 4500, 'IdeaPad 3': 2800, 'IdeaPad 5': 3200, 'Legion 5': 5000, 'Legion 7': 6500 },
      'Заміна SSD': { 'ThinkPad X1 Carbon': 2800, 'ThinkPad T14': 2200, 'IdeaPad 3': 1600, 'IdeaPad 5': 1800, 'Legion 5': 2500, 'Legion 7': 3200 },
      'Ремонт після води': { 'ThinkPad X1 Carbon': 3500, 'ThinkPad T14': 3000, 'IdeaPad 3': 2000, 'IdeaPad 5': 2300, 'Legion 5': 3200, 'Legion 7': 4000 }
    }
  }
};

export const laptopCleaningData = {
  regular: 800,
  macbook: [
    { model: 'MacBook Air 11"/13" (2010-2017)', price: 800 },
    { model: 'MacBook Air 13" (M1/M2/M3)', price: 900 },
    { model: 'MacBook 12" Retina', price: 900 },
    { model: 'MacBook Pro 13" (2012-2020)', price: 900 },
    { model: 'MacBook Pro 13" (M1/M2)', price: 1000 },
    { model: 'MacBook Pro 14" (M1/M2/M3 Pro/Max)', price: 1200 },
    { model: 'MacBook Pro 15" (2013-2019)', price: 1200 },
    { model: 'MacBook Pro 16" (2019-2024)', price: 1400 }
  ],
  gaming: {
    ASUS: [
    { model: 'ROG G751JY', price: 1200 },
    { model: 'ROG GX500', price: 1300 },
    { model: 'ROG G501JW', price: 1200 },
    { model: 'ROG G752VT', price: 1300 },
    { model: 'ROG Strix GL502', price: 1300 },
    { model: 'ROG Strix GL703', price: 1400 },
    { model: 'ROG Zephyrus GX501', price: 1800 },
    { model: 'ROG Zephyrus M GM501', price: 1800 },
    { model: 'ROG Strix Scar II GL504', price: 1800 },
    { model: 'ROG Zephyrus S GX531', price: 1800 },
    { model: 'ROG Strix G G531', price: 1500 },
    { model: 'ROG Zephyrus Duo 15', price: 1800 },
    { model: 'ROG Zephyrus G14', price: 1800 },
    { model: 'ROG Zephyrus G15', price: 1800 },
    { model: 'ROG Strix G15', price: 1800 },
    { model: 'ROG Strix SCAR 15', price: 1800 },
    { model: 'TUF Dash F15', price: 1500 },
    { model: 'ROG Zephyrus M16', price: 2500 },
    { model: 'ROG Strix G16', price: 2500 },
    { model: 'ROG Zephyrus G14', price: 2500 },
    { model: 'ROG Strix SCAR 17', price: 2500 },
    { model: 'ROG Zephyrus G16', price: 2500 },
    { model: 'ROG Strix G18', price: 2500 },
    { model: 'TUF Gaming A17', price: 1800 },
    { model: 'TUF Gaming A16 Advantage', price: 1800 },
    { model: 'ROG Zephyrus G14', price: 2700 },
    { model: 'ROG Zephyrus G16', price: 2700 },
    { model: 'ROG Strix SCAR 18', price: 2700 },
    { model: 'ROG Flow Z13', price: 2700 },
    { model: 'TUF Gaming A18', price: 2000 },
    { model: 'TUF Gaming F15', price: 2000 },
    { model: 'TUF Gaming A15', price: 2000 }
    ],
    MSI: [
    { model: 'GT72 Titan', price: 1200 },
    { model: 'GE62 Apache', price: 1200 },
    { model: 'GT75 Titan', price: 1300 },
    { model: 'GE63 Raider', price: 1300 },
    { model: 'GS73VR Stealth', price: 1400 },
    { model: 'GE75 Raider', price: 1800 },
    { model: 'GS75 Stealth', price: 1800 },
    { model: 'GT76 Titan', price: 1800 },
    { model: 'GL63 Leopard', price: 1500 },
    { model: 'GE66 Raider', price: 1800 },
    { model: 'GS66 Stealth', price: 1800 },
    { model: 'GP65 Leopard', price: 1500 },
    { model: 'GL65 Leopard', price: 1500 },
    { model: 'GE76 Raider', price: 2500 },
    { model: 'GS77 Stealth', price: 2500 },
    { model: 'GT77 Titan', price: 2500 },
    { model: 'GP66 Leopard', price: 1800 },
    { model: 'GL66 Pulse', price: 1800 },
    { model: 'GE78 Raider', price: 2700 },
    { model: 'GS68 Stealth', price: 2700 },
    { model: 'GT78 Titan', price: 2700 },
    { model: 'GP78 Vector', price: 2000 },
    { model: 'GL68 Crosshair', price: 2000 },
    { model: 'Katana 15', price: 2000 },
    { model: 'Cyborg 15', price: 2000 }
    ],
    Acer: [
    { model: 'Predator Helios 300', price: 1300 },
    { model: 'Nitro 5', price: 1200 },
    { model: 'Predator Triton 700', price: 1400 },
    { model: 'Predator Helios 500', price: 1800 },
    { model: 'Predator Triton 500', price: 1800 },
    { model: 'Nitro 7', price: 1500 },
    { model: 'Predator Helios 300', price: 1500 },
    { model: 'Nitro 5', price: 1500 },
    { model: 'Predator Triton 300', price: 1800 },
    { model: 'Predator Helios 700', price: 1800 },
    { model: 'Predator Triton 500 SE', price: 2500 },
    { model: 'Predator Helios 300', price: 1800 },
    { model: 'Nitro 5', price: 1800 },
    { model: 'Predator Triton 16', price: 2500 },
    { model: 'Predator Helios 16', price: 2500 },
    { model: 'Predator Helios 18', price: 2500 },
    { model: 'Nitro 16', price: 1800 },
    { model: 'Nitro 17', price: 1800 },
    { model: 'Predator Triton 14 AI', price: 2700 },
    { model: 'Predator Helios Neo 16', price: 2000 },
    { model: 'Nitro V 15', price: 2000 },
    { model: 'Nitro V 16', price: 2000 }
    ],
    Lenovo: [
    { model: 'Legion Y520', price: 1200 },
    { model: 'Legion Y720', price: 1300 },
    { model: 'Legion Y730', price: 1400 },
    { model: 'Legion Y740', price: 1800 },
    { model: 'Legion 5', price: 1500 },
    { model: 'Legion 5 Pro', price: 1800 },
    { model: 'Legion 7', price: 2500 },
    { model: 'Legion Slim 7', price: 2500 },
    { model: 'Legion 5', price: 1800 },
    { model: 'Legion 5i Pro', price: 2500 },
    { model: 'Legion 7i', price: 2500 },
    { model: 'Legion Pro 7i', price: 2500 },
    { model: 'Legion 9i', price: 2700 },
    { model: 'Legion Pro 5', price: 2000 },
    { model: 'Legion 5 (2024)', price: 2000 },
    { model: 'Legion Pro 7i Gen9 (2025)', price: 2700 },
    { model: 'Legion 9i Gen9 (2025)', price: 2700 },
    { model: 'Legion Slim 5 (2025)', price: 2700 },
    { model: 'LOQ 15 (2024)', price: 2000 },
    { model: 'LOQ 15i (2025)', price: 2000 }
    ],
    HP: [
    { model: 'OMEN 15 (2016)', price: 1200 },
    { model: 'OMEN 17 (2017)', price: 1300 },
    { model: 'OMEN X 17', price: 1400 },
    { model: 'OMEN 15 (2019)', price: 1500 },
    { model: 'OMEN 17 (2019)', price: 1500 },
    { model: 'OMEN 15 (2020)', price: 1800 },
    { model: 'OMEN 16 (2021)', price: 1800 },
    { model: 'OMEN 17 (2021)', price: 1800 },
    { model: 'Victus 15 (2021)', price: 1500 },
    { model: 'Victus 16 (2021)', price: 1500 },
    { model: 'OMEN 16 (2022)', price: 2500 },
    { model: 'OMEN 17 (2022)', price: 2500 },
    { model: 'OMEN Transcend 14', price: 2500 },
    { model: 'OMEN 16 (2023)', price: 2500 },
    { model: 'Victus 16 (2023)', price: 1800 },
    { model: 'OMEN Transcend 16', price: 2700 },
    { model: 'OMEN 16 (2024)', price: 2700 },
    { model: 'OMEN 17 (2024)', price: 2700 },
    { model: 'Victus 15 (2024)', price: 2000 },
    { model: 'Victus 16 (2025)', price: 2000 },
    { model: 'OMEN Max 16 (2025)', price: 2700 }
    ],
    Dell: [
    { model: 'Alienware M15 (2015)', price: 1300 },
    { model: 'Alienware 17 R3', price: 1400 },
    { model: 'Alienware 15 R3', price: 1400 },
    { model: 'Alienware 17 R4', price: 1500 },
    { model: 'Alienware M17 (2019)', price: 1800 },
    { model: 'Alienware M15 R2', price: 1800 },
    { model: 'Alienware Area-51m', price: 1800 },
    { model: 'Alienware M15 R4', price: 1800 },
    { model: 'Alienware X17 R1', price: 2500 },
    { model: 'Alienware M17 R4', price: 2500 },
    { model: 'Alienware X15 R1', price: 2500 },
    { model: 'Alienware M16 R1', price: 2500 },
    { model: 'Alienware X17 R2', price: 2500 },
    { model: 'Alienware M18 R1', price: 2500 },
    { model: 'G15 5510', price: 1500 },
    { model: 'G16 7620', price: 1800 },
    { model: 'G15 5530', price: 1800 },
    { model: 'Alienware M16 R2 (2024)', price: 2700 },
    { model: 'Alienware X16 R2 (2024)', price: 2700 },
    { model: 'Alienware M18 R2 (2025)', price: 2700 },
    { model: 'Alienware X14 R3 (2025)', price: 2700 },
    { model: 'G16 7630 (2025)', price: 2000 },
    { model: 'G15 (2025)', price: 2000 }
    ]
  }
};

export const phoneRepairData = {
  Apple: {
    models: ['iPhone 15 Pro Max', 'iPhone 15 Pro', 'iPhone 15', 'iPhone 14 Pro Max', 'iPhone 14 Pro', 'iPhone 14', 'iPhone 13 Pro Max', 'iPhone 13 Pro', 'iPhone 13', 'iPhone 12 Pro Max', 'iPhone 12 Pro', 'iPhone 12', 'iPhone 11 Pro Max', 'iPhone 11 Pro', 'iPhone 11', 'iPhone XS Max', 'iPhone XS', 'iPhone XR', 'iPhone X', 'iPhone 8 Plus', 'iPhone 8', 'iPhone 7 Plus', 'iPhone 7'],
    repairs: {
      'Заміна екрану': { 'iPhone 15 Pro Max': { original: 18500, copy: 9750 }, 'iPhone 15 Pro': { original: 17000, copy: 8700 }, 'iPhone 15': { original: 16000, copy: 8000 }, 'iPhone 14 Pro Max': { original: 18000, copy: 7550 }, 'iPhone 14 Pro': { original: 15900, copy: 7000 }, 'iPhone 14': { original: 9600, copy: 5750 }, 'iPhone 13 Pro Max': { original: 15500, copy: 7200 }, 'iPhone 13 Pro': { original: 13400, copy: 6500 }, 'iPhone 13': { original: 10500, copy: 5250 }, 'iPhone 12 Pro Max': { original: 10500, copy: 5400 }, 'iPhone 12 Pro': { original: 8000, copy: 4550 }, 'iPhone 12': { original: 8000, copy: 4500 }, 'iPhone 11 Pro Max': { original: 7800, copy: 4000 }, 'iPhone 11 Pro': { original: 5500, copy: 3000 }, 'iPhone 11': { original: 4500, copy: 2500 }, 'iPhone XS Max': { copy: 2700 }, 'iPhone XS': { copy: 2700 }, 'iPhone XR': { original: 3500, copy: 1700 }, 'iPhone X': { original: 3500, copy: 1700 }, 'iPhone 8 Plus': { copy: 1500 }, 'iPhone 8': { copy: 1400 }, 'iPhone 7 Plus': { copy: 1000 }, 'iPhone 7': { copy: 1000 } },
      'Заміна батареї': { 'iPhone 15 Pro Max': { original: 1500, copy: 750 }, 'iPhone 15 Pro': { original: 1400, copy: 700 }, 'iPhone 15': { original: 1300, copy: 650 }, 'iPhone 14 Pro Max': { original: 1300, copy: 650 }, 'iPhone 14 Pro': { original: 5500, copy: 2500 }, 'iPhone 14': { original: 1100, copy: 550 }, 'iPhone 13 Pro Max': { original: 1100, copy: 550 }, 'iPhone 13 Pro': { original: 1000, copy: 500 }, 'iPhone 13': { original: 900, copy: 450 }, 'iPhone 12 Pro Max': { original: 1000, copy: 500 }, 'iPhone 12 Pro': { original: 8000, copy: 4500 }, 'iPhone 12': { original: 8000, copy: 4500 }, 'iPhone 11 Pro Max': { original: 7850, copy: 4000 }, 'iPhone 11 Pro': { original: 800, copy: 400 }, 'iPhone 11': { original: 750, copy: 375 }, 'iPhone XS Max': { original: 800, copy: 400 }, 'iPhone XS': { original: 750, copy: 375 }, 'iPhone XR': { original: 700, copy: 350 }, 'iPhone X': { original: 700, copy: 350 }, 'iPhone 8 Plus': { original: 650, copy: 325 }, 'iPhone 8': { original: 600, copy: 300 }, 'iPhone 7 Plus': { original: 550, copy: 275 }, 'iPhone 7': { original: 500, copy: 250 } },
      'Заміна камери': { 'iPhone 15 Pro Max': 2500, 'iPhone 15 Pro': 2300, 'iPhone 15': 2000, 'iPhone 14 Pro Max': 2200, 'iPhone 14 Pro': 2000, 'iPhone 14': 1800, 'iPhone 13 Pro Max': 1800, 'iPhone 13 Pro': 1600, 'iPhone 13': 1400, 'iPhone 12 Pro Max': 1600, 'iPhone 12 Pro': 1500, 'iPhone 12': 1300, 'iPhone 11 Pro Max': 1400, 'iPhone 11 Pro': 1300, 'iPhone 11': 1200, 'iPhone XS Max': 1200, 'iPhone XS': 1100, 'iPhone XR': 1000, 'iPhone X': 1000, 'iPhone 8 Plus': 900, 'iPhone 8': 850, 'iPhone 7 Plus': 800, 'iPhone 7': 750 },
      'Заміна роз\'єму зарядки': { 'iPhone 15 Pro Max': 900, 'iPhone 15 Pro': 850, 'iPhone 15': 800, 'iPhone 14 Pro Max': 850, 'iPhone 14 Pro': 800, 'iPhone 14': 750, 'iPhone 13 Pro Max': 750, 'iPhone 13 Pro': 700, 'iPhone 13': 650, 'iPhone 12 Pro Max': 700, 'iPhone 12 Pro': 680, 'iPhone 12': 650, 'iPhone 11 Pro Max': 650, 'iPhone 11 Pro': 620, 'iPhone 11': 600, 'iPhone XS Max': 600, 'iPhone XS': 580, 'iPhone XR': 550, 'iPhone X': 550, 'iPhone 8 Plus': 500, 'iPhone 8': 480, 'iPhone 7 Plus': 450, 'iPhone 7': 400 }
    }
  },
  Samsung: {
    models: ['Galaxy S25 Ultra','Galaxy S25+','Galaxy S25','Galaxy S25 Edge','Galaxy S24 Ultra','Galaxy S24+','Galaxy S24','Galaxy S24 FE','Galaxy S23 Ultra','Galaxy S23+','Galaxy S23','Galaxy S23 FE','Galaxy S22 Ultra','Galaxy S22+','Galaxy S22','Galaxy S21 Ultra','Galaxy S21+','Galaxy S21','Galaxy S21 FE','Galaxy S20 Ultra','Galaxy S20+','Galaxy S20','Galaxy S20 FE','Galaxy S10+','Galaxy S10','Galaxy S10e','Galaxy S9+','Galaxy S9','Galaxy Note 20 Ultra','Galaxy Note 20','Galaxy Note 10+','Galaxy Note 10','Galaxy Note 10 Lite','Galaxy Note 9','Galaxy A56','Galaxy A55','Galaxy A54','Galaxy A53','Galaxy A52','Galaxy A51','Galaxy A50','Galaxy A42','Galaxy A41','Galaxy A40','Galaxy A36','Galaxy A35','Galaxy A34','Galaxy A33','Galaxy A32','Galaxy A31','Galaxy A30','Galaxy A26','Galaxy A25','Galaxy A24','Galaxy A23','Galaxy A22','Galaxy A21','Galaxy A20','Galaxy A16','Galaxy A15','Galaxy A14','Galaxy A13','Galaxy A12','Galaxy A11','Galaxy A10','Galaxy A9 (2018)','Galaxy A8 (2018)','Galaxy A7 (2018)','Galaxy A6+','Galaxy A6','Galaxy M55','Galaxy M35','Galaxy M15','Galaxy M54','Galaxy M34','Galaxy M14','Galaxy M53','Galaxy M33','Galaxy M23','Galaxy M13'],
    repairs: {
      'Заміна екрану': {
        'Galaxy S25 Ultra': { 'original': 18999, 'copy': 9999 },
        'Galaxy S25+': { 'original': 11999, 'copy': 5999 },
        'Galaxy S25': { 'original': 9999, 'copy': 6499 },
        'Galaxy S25 Edge': { 'original': 17999, 'copy': 9799 },
        'Galaxy S24 Ultra': { 'original': 15999, 'copy': 9899 },
        'Galaxy S24+': { 'original': 11499, 'copy': 7499 },
        'Galaxy S24': { 'original': 9499, 'copy': 4599 },
        'Galaxy S24 FE': { 'original': 7999, 'copy': 4799 },
        'Galaxy S23 Ultra': { 'original': 15999, 'copy':7799 },
        'Galaxy S23+': { 'original': 7999, 'copy': 5499 },
        'Galaxy S23': { 'original': 7999, 'copy': 4399 },
        'Galaxy S23 FE': { 'original': 6499, 'copy': 3900 },
        'Galaxy S22 Ultra': { 'original': 13499, 'copy': 6799 },
        'Galaxy S22+': { 'original': 9999, 'copy': 6499 },
        'Galaxy S22': { 'original': 8799, 'copy': 4299 },
        'Galaxy S21 Ultra': { 'original': 12999, 'copy': 5999 },
        'Galaxy S21+': { 'original': 9999, 'copy': 4900 },
        'Galaxy S21': { 'original': 7999, 'copy': 5000 },
        'Galaxy S21 FE': { 'original': 7999, 'copy': 3999 },
        'Galaxy S20 Ultra': { 'original': 9999, 'copy': 4999 },
        'Galaxy S20+': { 'original': 8999, 'copy': 5099 },
        'Galaxy S20': { 'original': 8999, 'copy': 4999 },
        'Galaxy S20 FE': { 'original': 6499, 'copy': 3799 },
        'Galaxy S10+': { 'original': 11499, 'copy': 3499 },
        'Galaxy S10': { 'original': 9499, 'copy': 2999 },
        'Galaxy S10e': { 'original': 9499, 'copy': 2899 },
        'Galaxy S9+': { 'original': 8999, 'copy': 2999 },
        'Galaxy S9': { 'original': 7999, 'copy': 2999 },
        'Galaxy Note 20 Ultra': { 'original': 12999, 'copy': 5499 },
        'Galaxy Note 20': { 'original': 8999, 'copy': 3999 },
        'Galaxy Note 10+': { 'original': 12999, 'copy': 3999 },
        'Galaxy Note 10': { 'original': 10999, 'copy': 3999 },
        'Galaxy Note 10 Lite': { 'original': 9499, 'copy': 4499 },
        'Galaxy Note 9': { 'original': 10999, 'copy': 4999 },
        'Galaxy A56': { 'original': 5499, 'copy': 2299 },
        'Galaxy A55': { 'original': 4999, 'copy': 2999 },
        'Galaxy A54': { 'original': 4899, 'copy': 2799 },
        'Galaxy A53': { 'original': 5999, 'copy': 2999 },
        'Galaxy A52': { 'original': 4799, 'copy': 2799 },
        'Galaxy A51': { 'original': 4499, 'copy': 2699 },
        'Galaxy A50': { 'original': 4899, 'copy': 2799 },
        'Galaxy A42': { 'original': 3999, 'copy': 2599 },
        'Galaxy A41': { 'original': 3999, 'copy': 2599 },
        'Galaxy A40': { 'original': 3999, 'copy': 1999 },
        'Galaxy A36': { 'original': 4799, 'copy': 2799 },
        'Galaxy A35': { 'original': 4699, 'copy': 2699 },
        'Galaxy A34': { 'original': 4999, 'copy': 2799 },
        'Galaxy A33': { 'original': 4999, 'copy': 2699 },
        'Galaxy A32': { 'original': 3999, 'copy': 1999 },
        'Galaxy A31': { 'original': 4699, 'copy': 1899 },
        'Galaxy A30': { 'original': 3799, 'copy': 1899 },
        'Galaxy A26': { 'original': 4499, 'copy': 2299 },
        'Galaxy A25': { 'original': 4499, 'copy': 2699 },
        'Galaxy A24': { 'original': 4999, 'copy': 2899 },
        'Galaxy A23': { 'original': 2999, 'copy': 1699 },
        'Galaxy A22': { 'original': 3699, 'copy': 1899 },
        'Galaxy A21': { 'original': 3499, 'copy': 1799 },
        'Galaxy A20': { 'original': 2999, 'copy': 1599 },
        'Galaxy A16': { 'original': 3699, 'copy': 1899 },
        'Galaxy A15': { 'original': 3599, 'copy': 1999 },
        'Galaxy A14': { 'original': 3499, 'copy': 1799 },
        'Galaxy A13': { 'original': 2999, 'copy': 1499 },
        'Galaxy A12': { 'original': 2899, 'copy': 1499 },
        'Galaxy A11': { 'original': 2299, 'copy': 1399 },
        'Galaxy A10': { 'original': 1599, 'copy': 999 },
        'Galaxy A9 (2018)': { 'original': 4499, 'copy': 1999 },
        'Galaxy A8 (2018)': { 'original': 3399, 'copy': 1699 },
        'Galaxy A7 (2018)': { 'original': 4499, 'copy': 1999 },
        'Galaxy A6+': { 'original': 4399, 'copy': 1999 },
        'Galaxy A6': { 'original': 3799, 'copy': 1899 },
        'Galaxy M55': { 'original': 5999, 'copy':2999 },
        'Galaxy M35': { 'original': 6999, 'copy': 3499 },
        'Galaxy M15': { 'original': 3799, 'copy': 1799 },
        'Galaxy M54': { 'original': 3799, 'copy': 1799 },
        'Galaxy M34': { 'original': 4799, 'copy': 2499 },
        'Galaxy M14': { 'original': 1899, 'copy': 1199 },
        'Galaxy M53': { 'original': 5299, 'copy': 2799 },
        'Galaxy M33': { 'original': 3599, 'copy': 1999 },
        'Galaxy M23': { 'original': 3699, 'copy': 1899 },
        'Galaxy M13': { 'original': 3499, 'copy': 1799 }
      },
      'Заміна батареї': {
        'Galaxy S25 Ultra': { 'original': 2600, 'copy': 1500 },
        'Galaxy S25+': { 'original': 2600, 'copy': 1500 },
        'Galaxy S25': { 'original': 2600, 'copy': 1500 },
        'Galaxy S25 Edge': { 'original': 2600, 'copy': 1500 },
        'Galaxy S24 Ultra': { 'original': 2600, 'copy': 1500 },
        'Galaxy S24+': { 'original': 2600, 'copy': 1500 },
        'Galaxy S24': { 'original': 2600, 'copy': 1500 },
        'Galaxy S24 FE': { 'original': 2600, 'copy': 1500 },
        'Galaxy S23 Ultra': { 'original': 2600, 'copy': 1500 },
        'Galaxy S23+': { 'original': 2600, 'copy': 1500 },
        'Galaxy S23': { 'original': 2600, 'copy': 1500 },
        'Galaxy S23 FE': { 'original': 2600, 'copy': 1500 },
        'Galaxy S22 Ultra': { 'original': 2600, 'copy': 1500 },
        'Galaxy S22+': { 'original': 2600, 'copy': 1500 },
        'Galaxy S22': { 'original': 2600, 'copy': 1500 },
        'Galaxy S21 Ultra': { 'original': 2600, 'copy': 1500 },
        'Galaxy S21+': { 'original': 2600, 'copy': 1500 },
        'Galaxy S21': { 'original': 2600, 'copy': 1500 },
        'Galaxy S21 FE': { 'original': 2600, 'copy': 1500 },
        'Galaxy S20 Ultra': { 'original': 2600, 'copy': 1500 },
        'Galaxy S20+': { 'original': 2600, 'copy': 1500 },
        'Galaxy S20': { 'original': 2600, 'copy': 1500 },
        'Galaxy S20 FE': { 'original': 2600, 'copy': 1500 },
        'Galaxy S10+': { 'original': 2600, 'copy': 1500 },
        'Galaxy S10': { 'original': 2600, 'copy': 1500 },
        'Galaxy S10e': { 'original': 2600, 'copy': 1500 },
        'Galaxy S9+': { 'original': 2600, 'copy': 1500 },
        'Galaxy S9': { 'original': 2600, 'copy': 1500 },
        'Galaxy Note 20 Ultra': { 'original': 2600, 'copy': 1500 },
        'Galaxy Note 20': { 'original': 2600, 'copy': 1500 },
        'Galaxy Note 10+': { 'original': 2600, 'copy': 1500 },
        'Galaxy Note 10': { 'original': 2600, 'copy': 1500 },
        'Galaxy Note 10 Lite': { 'original': 2600, 'copy': 1500 },
        'Galaxy Note 9': { 'original': 2600, 'copy': 1500 },
        'Galaxy A56': { 'original': 900 },
        'Galaxy A55': { 'original': 900 },
        'Galaxy A54': { 'original': 900 },
        'Galaxy A53': { 'original': 900 },
        'Galaxy A52': { 'original': 900 },
        'Galaxy A51': { 'original': 900 },
        'Galaxy A50': { 'original': 900 },
        'Galaxy A42': { 'original': 900 },
        'Galaxy A41': { 'original': 900 },
        'Galaxy A40': { 'original': 900 },
        'Galaxy A36': { 'original': 900 },
        'Galaxy A35': { 'original': 900 },
        'Galaxy A34': { 'original': 900 },
        'Galaxy A33': { 'original': 900 },
        'Galaxy A32': { 'original': 900 },
        'Galaxy A31': { 'original': 900 },
        'Galaxy A30': { 'original': 900 },
        'Galaxy A26': { 'original': 900 },
        'Galaxy A25': { 'original': 900 },
        'Galaxy A24': { 'original': 900 },
        'Galaxy A23': { 'original': 900 },
        'Galaxy A22': { 'original': 900 },
        'Galaxy A21': { 'original': 900 },
        'Galaxy A20': { 'original': 900 },
        'Galaxy A16': { 'original': 900 },
        'Galaxy A15': { 'original': 900 },
        'Galaxy A14': { 'original': 900 },
        'Galaxy A13': { 'original': 900 },
        'Galaxy A12': { 'original': 900 },
        'Galaxy A11': { 'original': 900 },
        'Galaxy A10': { 'original': 900 },
        'Galaxy A9 (2018)': { 'original': 900 },
        'Galaxy A8 (2018)': { 'original': 900 },
        'Galaxy A7 (2018)': { 'original': 900 },
        'Galaxy A6+': { 'original': 900 },
        'Galaxy A6': { 'original': 900 },
        'Galaxy M55': { 'original': 900 },
        'Galaxy M35': { 'original': 900 },
        'Galaxy M15': { 'original': 900 },
        'Galaxy M54': { 'original': 900 },
        'Galaxy M34': { 'original': 900 },
        'Galaxy M14': { 'original': 900 },
        'Galaxy M53': { 'original': 900 },
        'Galaxy M33': { 'original': 900 },
        'Galaxy M23': { 'original': 900 },
        'Galaxy M13': { 'original': 900 }
      },
      'Заміна роз\'єму зарядки': {
        'Galaxy S25 Ultra': { 'original': 1400 },
        'Galaxy S25+': { 'original': 1400 },
        'Galaxy S25': { 'original': 1400 },
        'Galaxy S25 Edge': { 'original': 1400 },
        'Galaxy S24 Ultra': { 'original': 1400 },
        'Galaxy S24+': { 'original': 1400 },
        'Galaxy S24': { 'original': 1400 },
        'Galaxy S24 FE': { 'original': 1400 },
        'Galaxy S23 Ultra': { 'original': 1400 },
        'Galaxy S23+': { 'original': 1400 },
        'Galaxy S23': { 'original': 1400 },
        'Galaxy S23 FE': { 'original': 1400 },
        'Galaxy S22 Ultra': { 'original': 1400 },
        'Galaxy S22+': { 'original': 1400 },
        'Galaxy S22': { 'original': 1400 },
        'Galaxy S21 Ultra': { 'original': 1400 },
        'Galaxy S21+': { 'original': 1400 },
        'Galaxy S21': { 'original': 1400 },
        'Galaxy S21 FE': { 'original': 1400 },
        'Galaxy S20 Ultra': { 'original': 1400 },
        'Galaxy S20+': { 'original': 1400 },
        'Galaxy S20': { 'original': 1400 },
        'Galaxy S20 FE': { 'original': 1400 },
        'Galaxy S10+': { 'original': 1400 },
        'Galaxy S10': { 'original': 1400 },
        'Galaxy S10e': { 'original': 1400 },
        'Galaxy S9+': { 'original': 1400 },
        'Galaxy S9': { 'original': 1400 },
        'Galaxy Note 20 Ultra': { 'original': 1200 },
        'Galaxy Note 20': { 'original': 1200 },
        'Galaxy Note 10+': { 'original': 1200 },
        'Galaxy Note 10': { 'original': 1200 },
        'Galaxy Note 10 Lite': { 'original': 1200 },
        'Galaxy Note 9': { 'original': 1200 },
        'Galaxy A56': { 'original': 700 },
        'Galaxy A55': { 'original': 700 },
        'Galaxy A54': { 'original': 700 },
        'Galaxy A53': { 'original': 700 },
        'Galaxy A52': { 'original': 700 },
        'Galaxy A51': { 'original': 700 },
        'Galaxy A50': { 'original': 700 },
        'Galaxy A42': { 'original': 700 },
        'Galaxy A41': { 'original': 700 },
        'Galaxy A40': { 'original': 700 },
        'Galaxy A36': { 'original': 700 },
        'Galaxy A35': { 'original': 700 },
        'Galaxy A34': { 'original': 700 },
        'Galaxy A33': { 'original': 700 },
        'Galaxy A32': { 'original': 700 },
        'Galaxy A26': { 'original': 700 },
        'Galaxy A25': { 'original': 700 },
        'Galaxy A24': { 'original': 700 },
        'Galaxy A16': { 'original': 700 },
        'Galaxy A15': { 'original': 700 },
        'Galaxy A14': { 'original': 700 },
        'Galaxy M55': { 'original': 700 },
        'Galaxy M35': { 'original': 700 },
        'Galaxy M15': { 'original': 700 },
        'Galaxy M54': { 'original': 700 },
        'Galaxy M34': { 'original': 700 },
        'Galaxy M14': { 'original': 700 },
        'Galaxy M53': { 'original': 700 },
        'Galaxy M33': { 'original': 700 },
        'Galaxy M23': { 'original': 700 },
        'Galaxy M13': { 'original': 700 },
        'Galaxy A31': { 'original': 500 },
        'Galaxy A30': { 'original': 500 },
        'Galaxy A23': { 'original': 500 },
        'Galaxy A22': { 'original': 500 },
        'Galaxy A21': { 'original': 500 },
        'Galaxy A20': { 'original': 500 },
        'Galaxy A13': { 'original': 500 },
        'Galaxy A12': { 'original': 500 },
        'Galaxy A11': { 'original': 500 },
        'Galaxy A10': { 'original': 500 },
        'Galaxy A9 (2018)': { 'original': 500 },
        'Galaxy A8 (2018)': { 'original': 500 },
        'Galaxy A7 (2018)': { 'original': 500 },
        'Galaxy A6+': { 'original': 500 },
        'Galaxy A6': { 'original': 500 }
      }
    }
  },
  Xiaomi: {
    models: ['Xiaomi 14 Ultra', 'Xiaomi 14 Pro', 'Xiaomi 14', 'Xiaomi 13 Ultra', 'Xiaomi 13 Pro', 'Xiaomi 13', 'Xiaomi 12 Pro', 'Xiaomi 12', 'Xiaomi 11', 'Redmi Note 13 Pro', 'Redmi Note 13', 'Redmi Note 12 Pro', 'Redmi Note 12', 'Redmi Note 11', 'Poco X6 Pro', 'Poco X6', 'Poco F5'],
    repairs: {
      'Заміна екрану': { 'Xiaomi 14 Ultra': { original: 4500, copy: 2250 }, 'Xiaomi 14 Pro': { original: 4200, copy: 2100 }, 'Xiaomi 14': { original: 3800, copy: 1900 }, 'Xiaomi 13 Ultra': { original: 4200, copy: 2100 }, 'Xiaomi 13 Pro': { original: 3800, copy: 1900 }, 'Xiaomi 13': { original: 3500, copy: 1750 }, 'Xiaomi 12 Pro': { original: 3500, copy: 1750 }, 'Xiaomi 12': { original: 3200, copy: 1600 }, 'Xiaomi 11': { original: 3000, copy: 1500 }, 'Redmi Note 13 Pro': { original: 2200, copy: 1100 }, 'Redmi Note 13': { original: 1900, copy: 950 }, 'Redmi Note 12 Pro': { original: 2000, copy: 1000 }, 'Redmi Note 12': { original: 1700, copy: 850 }, 'Redmi Note 11': { original: 1600, copy: 800 }, 'Poco X6 Pro': { original: 2100, copy: 1050 }, 'Poco X6': { original: 1900, copy: 950 }, 'Poco F5': { original: 2000, copy: 1000 } },
      'Заміна батареї': { 'Xiaomi 14 Ultra': { original: 900, copy: 450 }, 'Xiaomi 14 Pro': { original: 850, copy: 425 }, 'Xiaomi 14': { original: 800, copy: 400 }, 'Xiaomi 13 Ultra': { original: 850, copy: 425 }, 'Xiaomi 13 Pro': { original: 800, copy: 400 }, 'Xiaomi 13': { original: 750, copy: 375 }, 'Xiaomi 12 Pro': { original: 750, copy: 375 }, 'Xiaomi 12': { original: 700, copy: 350 }, 'Xiaomi 11': { original: 650, copy: 325 }, 'Redmi Note 13 Pro': { original: 600, copy: 300 }, 'Redmi Note 13': { original: 550, copy: 275 }, 'Redmi Note 12 Pro': { original: 550, copy: 275 }, 'Redmi Note 12': { original: 500, copy: 250 }, 'Redmi Note 11': { original: 480, copy: 240 }, 'Poco X6 Pro': { original: 580, copy: 290 }, 'Poco X6': { original: 550, copy: 275 }, 'Poco F5': { original: 560, copy: 280 } },
      'Заміна роз\'єму зарядки': { 'Xiaomi 14 Ultra': 650, 'Xiaomi 14 Pro': 620, 'Xiaomi 14': 600, 'Xiaomi 13 Ultra': 620, 'Xiaomi 13 Pro': 600, 'Xiaomi 13': 580, 'Xiaomi 12 Pro': 580, 'Xiaomi 12': 550, 'Xiaomi 11': 520, 'Redmi Note 13 Pro': 450, 'Redmi Note 13': 420, 'Redmi Note 12 Pro': 430, 'Redmi Note 12': 400, 'Redmi Note 11': 380, 'Poco X6 Pro': 440, 'Poco X6': 420, 'Poco F5': 430 }
    }
  },
  Huawei: {
    models: ['Huawei P60 Pro', 'Huawei P60', 'Huawei P50 Pro', 'Huawei P50', 'Huawei P40 Pro', 'Huawei P40', 'Huawei Mate 50 Pro', 'Huawei Mate 40 Pro', 'Huawei Nova 11', 'Huawei Nova 10'],
    repairs: {
      'Заміна екрану': { 'Huawei P60 Pro': { original: 4000, copy: 2000 }, 'Huawei P60': { original: 3500, copy: 1750 }, 'Huawei P50 Pro': { original: 3500, copy: 1750 }, 'Huawei P50': { original: 3200, copy: 1600 }, 'Huawei P40 Pro': { original: 3200, copy: 1600 }, 'Huawei P40': { original: 2800, copy: 1400 }, 'Huawei Mate 50 Pro': { original: 3800, copy: 1900 }, 'Huawei Mate 40 Pro': { original: 3500, copy: 1750 }, 'Huawei Nova 11': { original: 2500, copy: 1250 }, 'Huawei Nova 10': { original: 2300, copy: 1150 } },
      'Заміна батареї': { 'Huawei P60 Pro': { original: 850, copy: 425 }, 'Huawei P60': { original: 800, copy: 400 }, 'Huawei P50 Pro': { original: 800, copy: 400 }, 'Huawei P50': { original: 750, copy: 375 }, 'Huawei P40 Pro': { original: 750, copy: 375 }, 'Huawei P40': { original: 700, copy: 350 }, 'Huawei Mate 50 Pro': { original: 820, copy: 410 }, 'Huawei Mate 40 Pro': { original: 800, copy: 400 }, 'Huawei Nova 11': { original: 650, copy: 325 }, 'Huawei Nova 10': { original: 600, copy: 300 } },
      'Заміна роз\'єму зарядки': { 'Huawei P60 Pro': 600, 'Huawei P60': 580, 'Huawei P50 Pro': 580, 'Huawei P50': 550, 'Huawei P40 Pro': 550, 'Huawei P40': 520, 'Huawei Mate 50 Pro': 590, 'Huawei Mate 40 Pro': 580, 'Huawei Nova 11': 480, 'Huawei Nova 10': 450 }
    }
  }
};

export const mockFAQ = [
  {
    id: 1,
    question: 'Скільки коштує діагностика?',
    answer: 'Діагностика всіх пристроїв у нас абсолютно безкоштовна. Ми визначимо проблему та назвемо точну вартість ремонту без жодних прихованих платежів.'
  },
  {
    id: 2,
    question: 'Скільки часу займає ремонт?',
    answer: 'Більшість ремонтів виконуються за 1-2 години. Складні ремонти (заміна екрану ноутбука, ремонт плати) можуть зайняти від 1 до 3 днів. Після діагностики ми повідомимо точний термін.'
  },
  {
    id: 3,
    question: 'Які гарантії ви надаєте?',
    answer: 'Ми надаємо гарантію на всі виконані роботи та встановлені запчастини. Термін гарантії залежить від типу ремонту та обговорюється індивідуально (зазвичай від 1 до 6 місяців).'
  },
  {
    id: 4,
    question: 'Чи використовуєте ви оригінальні запчастини?',
    answer: 'Так, ми працюємо з оригінальними запчастинами та якісними аналогами від перевірених постачальників. Під час ремонту ви можете обрати тип запчастин залежно від вашого бюджету.'
  },
  {
    id: 5,
    question: 'Що робити, якщо телефон потрапив у воду?',
    answer: 'Негайно вимкніть пристрій і не намагайтесь його заряджати. Чим швидше ви принесете його до нас, тим більше шансів на відновлення. Ми проведемо професійну чистку та відновлення після попадання рідини.'
  },
  {
    id: 6,
    question: 'Чи можна відремонтувати старий ноутбук?',
    answer: 'Так, ми ремонтуємо ноутбуки будь-якого віку. Також можемо запропонувати апгрейд (збільшення RAM, установка SSD), що значно підвищить продуктивність вашого старого ноутбука.'
  },
  {
    id: 7,
    question: 'Як записатися на ремонт?',
    answer: 'Ви можете зателефонувати нам за номером +38 097 417 8788 або заповнити форму запису на сайті. Ми працюємо Пн-Сб з 11:00 до 18:00.'
  },
  {
    id: 8,
    question: 'Чи є у вас запчастини в наявності?',
    answer: 'Більшість популярних запчастин (екрани, батареї, камери) для iPhone, Samsung, Xiaomi та інших популярних моделей є в наявності. Рідкісні деталі можемо замовити протягом 1-2 днів.'
  }
];
